import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SessionStorageService {
    constructor() {}

    // Set item in session storage
    setItem(key: string, value: any): void {
        try {
            // If the value is a string, store it directly without JSON.stringify
            const storageValue = typeof value === 'string' ? value : JSON.stringify(value);
            sessionStorage.setItem(key, storageValue);
        } catch (error) {
            console.error('Error saving to session storage', error);
        }
    }

    // Get item from session storage
    getItem<T>(key: string): T | null {
        try {
            const value = sessionStorage.getItem(key);
            if (!value) return null;

            // Try parsing as JSON, if it fails return the raw string
            try {
                return JSON.parse(value);
            } catch {
                return value as unknown as T;
            }
        } catch (error) {
            console.error('Error reading from session storage', error);
            return null;
        }
    }

    // Remove item from session storage
    removeItem(key: string): void {
        sessionStorage.removeItem(key);
    }

    // Clear all session storage
    clear(): void {
        sessionStorage.clear();
    }

    // Check if key exists in session storage
    hasItem(key: string): boolean {
        return sessionStorage.getItem(key) !== null;
    }
}
